import { io } from "socket.io-client"

const URL = process.env.VUE_APP_SOCKET_URL
const socket = io(URL, { autoConnect: false })

socket.onAny((event, ...args) => {})

export default socket
